import React from "react";

const PlatformSimulationsSection = ({ data }) => (

    <section className="sx-platform-section sx-platform-simulations">

        <div className="container">

            <div className="sx-section-heading">

                <span>
                    {data.eyebrow}
                </span>

                <h2>
                    {data.title}
                </h2>

                {data.description && (
                    <p>
                        {data.description}
                    </p>
                )}

            </div>

            <div className="sx-simulation-grid">

                {(data.simulations || []).map(
                    (simulation, index) => (

                        <div
                            className="sx-simulation-card"
                            key={index}
                        >

                            <div className="sx-simulation-video">

                                <video
                                    controls
                                    preload="metadata"
                                    playsInline
                                >
                                    <source
                                        src={simulation.video}
                                        type="video/mp4"
                                    />

                                    Your browser does not support HTML5 video.

                                </video>

                            </div>

                            <div className="sx-simulation-content">

                                <span>
                                    {simulation.organization}
                                </span>

                                <h3>
                                    {simulation.title}
                                </h3>

                                <p>
                                    {simulation.description}
                                </p>

                                {simulation.link && (
                                    <a href={simulation.link.url}>
                                        {simulation.link.label}
                                    </a>
                                )}

                            </div>

                        </div>

                    )
                )}

            </div>

        </div>

    </section>
);

export default PlatformSimulationsSection;